import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { tenantApi } from '../api/tenant.api'
import { resolveMockRole } from '../data/mock-user'
import { authKeys } from '../query-keys'
import { useAuthStore } from '../stores/auth.store'

/**
 * Fetches the current account's tenant detail (`GET /admin/tenants/:id`) once
 * and mirrors it into the auth store so reporting-group / branch data is reused
 * across the app without refetching. Disabled in dev mock mode (the bootstrap
 * seeds a mock tenant instead) and when there is no tenant (super admin).
 */
export function useTenant() {
  const accountId = useAuthStore((s) => s.user?.accountId)
  const setTenant = useAuthStore((s) => s.setTenant)
  const enabled = !!accountId && !resolveMockRole()

  const query = useQuery({
    queryKey: authKeys.tenant(accountId ?? ''),
    queryFn: () => tenantApi.detail(accountId as string),
    enabled,
    staleTime: 5 * 60_000,
  })

  useEffect(() => {
    if (query.data) setTenant(query.data)
  }, [query.data, setTenant])

  return query
}
